import { Divider, message, Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Head from '../../components/Head'
import List from '../../components/List'
import Button from '../../components/UI/Button'
import { deleteDevicesVersionById, exportCsvDevicesVersions, getDeviceVersionsList } from '../../services/deviceVersions'
import { getPermission } from '../../services/permisssion'
import permissionType from '../../utils/permissionType'
import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined
} from '@ant-design/icons';
import direction from '../../utils/filterDirectionOrder'
import { notificationError } from '../../services/notification'
import { useLoading } from '../../context/LoadingProvider/useLoading'
import { sendSystemLog, useAuth } from '../../context/AuthProvider/useAuth'

function DeviceVersions(props: {accessLevel: string}) {
  const history = useNavigate()
  const {canEdit} = useAuth()
  const [versions, setVersions] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [idToDelete, setIdToDelete] = useState<null | string>(null)
  const [filter, setFilter] = useState({
    fieldOrder: '',
    directionOrder: '',
  })
  const loading = useLoading()
  const log = {
    log_type: 'visited',
    log_object: 'device_versions'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])

  useEffect(()=> {
    (async () => {
      loading.addLoading()
      const response  = await getDeviceVersionsList()
      if(response && response.list.length > 0) {
        setVersions(response.list)
      }
      loading.removeLoading()
    })()
  }, [])

  const exportCsv = async () => {
    loading.addLoading()
    await exportCsvDevicesVersions()
    loading.removeLoading()
  }

  const onChangeOrder = async (order: {column: any, field: string, order: string| undefined}) => {
    let newFilter = {
      fieldOrder: '',
      directionOrder: '',
    }

    if(order.column) {
     newFilter = {
      ...filter,
      fieldOrder: order.field,
      directionOrder: order.order === 'ascend' ? direction.asc : direction.desc,
     } 
    }
    const response  = await getDeviceVersionsList(newFilter)
    if(response && response.list.length > 0) {
      setVersions(response.list)
    }
    setFilter(newFilter)
  }

  const getActionButtons = (id: string) => {
    return (
      <div className="roles__button-actions">
        <Button
          disabled={!canEdit}
          onClick={() => history(`/deviceversions/new/${id}`)}
          type='primary'
          style={{ backgroundColor: '#2fa4e7' }}
        >
          <EditOutlined style={{ fontSize: '16px', color: '#FFF' }} />
        </Button>
        <Button
          disabled={!canEdit}
          onClick={() => openDeleteModal(id)}
          type='primary'
          style={{ backgroundColor: '#d41d24' }}
        >
          <DeleteOutlined style={{ fontSize: '16px', color: '#FFF' }} />
        </Button>
      </div>
    )
  }

  const openDeleteModal = (id: string) => {
    setIdToDelete(id)
    setModalVisible(true)
  }

  const deleteDeviceVersion = async () => {
    if(!idToDelete) return setModalVisible(false)
    await deleteDevicesVersionById({id: idToDelete})
    const response  = await getDeviceVersionsList()
    setVersions(response.list)
    setModalVisible(false)
  }



  return (
    <div className="device-versions">
      <Modal 
        title="Are you sure you want to delete it?"
        open={modalVisible}
        onOk={deleteDeviceVersion} 
        onCancel={() => setModalVisible(false)}
      />
      <Head title="Device Versions" buttonText='New Device Version' disabled={!canEdit} buttonAction={() => history('/deviceversions/new')} />
        <meta name="viewport" content="width=device-width, initial-scale=.5"/>
      <List
        rows={versions}
        onChange={(selectedRowKeys, selectedRows, order) => onChangeOrder(order)}
        columns={[
          {
            title: 'Device Version',
            dataIndex: 'deviceVersion',
            key: 'deviceVersion',
            render: (value: string) => value,
            width: 100,
            sorter: true,
          },
          {
            title: 'Valid Through',
            dataIndex: 'validThrough',
            key: 'validThrough',
            render: (value: string) => value,
            width: 100,
            sorter: true,
          },
          {
            title: 'Type',
            dataIndex: 'deviceType',
            key: 'deviceType',
            render: (value: string) => value,
            width: 100,
            sorter: true,
          },
          {
            title: 'Device Activation',
            dataIndex: 'deviceActivationEnabled',
            key: 'deviceActivationEnabled',
            render: (value: boolean) => value ? 'YES' : 'NO',
            width: 100,
            sorter: true,
          },
          {
            title: 'Offer Bundles On POS',
            dataIndex: 'posBundleServerEnabled',
            key: 'posBundleServerEnabled',
            render: (value: boolean) => value ? 'YES' : 'NO',
            width: 100,
            sorter: true,
          },
          {
            title: 'Actions',
            dataIndex: 'id',
            key: 'id',
            width: 100,
            render: (value: string) => getActionButtons(value),
          },
        ]}
      />
    </div>
  )
}

export default DeviceVersions